import { IFRAME_HEIGHT, IFRAME_WIDTH } from '../../constants';
import { getIframe, setAddEventListener } from '../../helpers';

const TermsView = {
  render: async () => {
    return `
    <div>
      <a id="connect_pay_back_button" class="c_back"></a>
    </div>
    <div class="c_terms_view_title1">${history.state.termsKndName}</div>
    <iframe id="term_content" style="border-width: 0px;" src="${history.state.termsPath}"></iframe>
    `;
  },
  afterRender: async () => {
    setAddEventListener('connect_pay_back_button', () => history.back());

    getIframe().getElementById('term_content').style.width = `${
      IFRAME_WIDTH - 34
    }`;
    getIframe().getElementById('term_content').style.height = `${
      IFRAME_HEIGHT - 163
    }`;
  },
};
export default TermsView;
